import {IDatabaseItemRouteSource} from '@toolify/client/src/modules/databases/types/IDatabaseItemRouteSource'

export function getDatabaseItemRouteSourceQuery({databaseId, viewId, isRelated}: IDatabaseItemRouteSource): Record<string, string> {
  if(!isRelated) {
    return viewId ? {viewId} : {}
  }
  return {
    ...(databaseId ? {fromDatabaseId: databaseId} : {}),
    ...(viewId ? {fromViewId: viewId} : {}),
  }
}
